import axios from 'axios'
import globalStore from '@/stores/global.svelte'

class CouponsStore {
  state = $state({
    coupons: []
  })

  couponsByName = $derived.by(() => {
    if (!this.state.coupons || !this.state.coupons.length) {
      return []
    }
    return this.state.coupons.sort( (a, b) => {
      let nameA = a.name.toUpperCase(); // ignore upper and lowercase
      let nameB = b.name.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    })
  })

  async fetch() {
    axios.get('/coupons.json')
      .then((response) => {
        this.state.coupons = response.data
        globalStore.setErrors([])
      })
      .catch((error) => {
        globalStore.setErrors(error)
      })
  }
}

const couponsStore = new CouponsStore()
export default couponsStore
